// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import i18n from './i18n/index'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import Print from 'vue-print-nb'
// import 'element-ui/lib/theme-default/index.css'
import 'element-ui/lib/theme-chalk/index.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import 'normalize.css/normalize.css'
import '@/assets/iconfont/iconfont'
import '@/assets/iconfont/newicon'
import IconSvg from '@/components/Icon-svg/index.vue'
import * as filters from '@/filters' // 全局filter
import { getToken, setToken } from '@/utils/auth'
import App from './App'
import Directive from './directive/index'
import dataV from '@jiaminghi/data-view';
import echarts from 'echarts';

Vue.prototype.$echarts = echarts
Vue.use(Directive)
// 自定义树选择组件
Vue.use(dataV);
// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(Print);
Vue.component('icon-svg', IconSvg)

const whiteList = ['/login', '/cabinet/stock', '/versionText'];
router.beforeEach((to, from, next) => {
  NProgress.start();
  if (to.query && to.query.token) {
    setToken(to.query.token);
    store.commit('SET_TOKEN', to.query.token);
    window.location.search = ''
  }
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' });
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => {
          const roles = res.data.role;
          store.dispatch('GenerateRoutes', { roles }).then(() => {
            router.addRoutes(store.getters.addRouters);
            next({ ...to });
          })
        })
      } else {
        next();
      }
    }
  } else {
        // next('/login');
    console.log(whiteList.indexOf(to.path), '000')
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else if (whiteList.indexOf(to.path) === 1) {
      next({ path: '/cabinet/stock' });
      NProgress.done();
    } else if (whiteList.indexOf(to.path) === 2) {
      next({ path: '/versionText' });
      NProgress.done();
    } else {
      next('/login');
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});

new Vue({
  el: '#app',
  i18n,
  router,
  store,
  created() {
        // 在Vue实例创建时启动token刷新任务
    this.$store.dispatch('startTokenRefresh');
  },
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js